<template>
  <div class="">
  <div class="nofount">
    <img src="@/assets/images/web.jpg" />
  </div>

   
  </div>
</template>

<script>

export default {
  name: "Nopage",

  components: {
   
  },

  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "酒店服务",
    };
  },
  methods: {},
  computed: {
  },
};
</script>
<style lang="less" scoped> 
  .nofount{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    
  }

  @media (min-width: 320px) and (max-width: 780px) {
  
    .nofount{
    width: 100%;
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
     img{
      width: 100%;
     }
  } 
  }
</style>
